import api from "@api";

import {log} from "@helpers";

const removerCartao = async (data, setCurrentProgress) => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser"));
  if (!currentUser) return;
  const payload = {
    pathWithDomain: `${process.env.REACT_APP_API_V2}/api/v1/forma_pagamento/${data.id}`,
    method: "DELETE",
  };
  log("DELETE removerCartao:", payload);

  return api(payload, setCurrentProgress);
};

export default removerCartao;
